<template>
  <div class="container-box">
    <el-form :data="tripInfo" :inline="false" size="small" label-width="88">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="上车站点：">{{ tripInfo.getOnStation }}</el-form-item>
          <el-form-item label="预定座位：">{{ tripInfo.reservedSeats }}</el-form-item>
          <el-form-item label="出发时间：">{{ tripInfo.departureDateTime }}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="下车站点：">{{ tripInfo.getOffStation }}</el-form-item>
          <el-form-item label="实际座位：">{{ tripInfo.actualSeats }}</el-form-item>
          <el-form-item v-if="isDoorToDoor" label="乘客端展示时间(门对门模式)：">
            {{ timeStr }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="公里数：">{{ tripInfo.mileage }}</el-form-item>
          <el-form-item label="预计时长：">{{ tripInfo.expectedTime }}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import dayjs from 'dayjs'
  export default {
    name: 'tripInfo',
    props: {
      info: {}
    },
    data() {
      return {}
    },
    computed: {
      tripInfo() {
        const { tripInfo } = this.info || {}
        return tripInfo || {}
      },
      isDoorToDoor() {
        const { modeType } = this.info
        return modeType === 2 || modeType === '2'
      },
      timeStr() {
        if (!this.isDoorToDoor) return ''
        const { preferredDepartureEnd, preferredDepartureStart } = this.info
        const date = dayjs(preferredDepartureStart).format('YYYY-MM-DD')
        const startTime = dayjs(preferredDepartureStart).format('HH:mm')
        const endTime = dayjs(preferredDepartureEnd).format('HH:mm')

        return `${date} ${startTime}-${endTime}`
      }
    }
  }
</script>

<style lang="scss" scoped>
  .container-box {
    margin: 12px 0;
    padding: 0 10px;
  }
</style>
